// All theme colors centralized here for usage with Next.js + Turbopack

// Slightly tinted instead of plain white so surfaces pick up the brand hue
const PAPER = '#fafafa';

export const colors = {
    // paper & background
    paper: PAPER,

    // surface layers: warm pink-tinted canvas below, lighter cards above
    canvas: '#fcf5f7',
    surface: PAPER,
    surfaceSubtle: '#f8f8fb',
    surfaceBorder: 'rgba(96, 95, 153, 0.10)',
    sidebar: 'color-mix(in srgb, #605f99 70%, #364152)',

    // primary
    primaryUltraLight: '#f9f8f8',
    primaryLight: '#eef2f6',
    primaryMain: '#605f99',
    primaryDark: '#4a4976',
    primary200: '#8281ca',
    primary800: '#4a4a7a',

    // secondary
    secondaryBgPinkHover: '#fbd9d7',
    secondaryBgPink: '#fce5e4',
    secondaryBgPinkDark: '#fceaea',
    secondaryLight: '#ede7f6',
    secondaryMain: '#8f61f7',
    secondaryDark: '#dc827c',
    secondary200: '#af8ff6',
    secondary800: '#fabbb7',

    // bot card tints (lightened secondary pink & violet)
    botCardSurface: '#fffafa',
    botCardSurfaceHover: '#fdf3f3',
    botCardBorder: '#f8e3e2',
    botCardPink: '#fcecec',
    botCardRose: '#f9e8f1',
    botCardLilac: '#f3ecfd',
    botCardViolet: '#ebe3fd',
    botCardAccent: '#6d4bc4',
    botCardPinkDark: '#b84a5e',

    // campaign calls result
    summaryPending: 'rgb(198, 198, 198)',
    summaryInitiated: 'rgb(225, 203, 107)',
    summaryDenied: 'rgb(255, 163, 50)',
    summaryToRetry:
        'repeating-linear-gradient(-45deg, white, white 1px, rgb(255, 163, 50) 1px, rgb(255, 163, 50) 10px)',
    summaryUnconnected: 'rgb(231, 76, 128)',
    summaryFinished: 'rgb(49, 139, 70)',

    // success
    successLight: '#b9f6ca',
    success200: '#69f0ae',
    successMain: '#00e676',
    successDark: '#00c853',

    // error
    errorLight: '#ef9a9a',
    errorMain: '#f44336',
    errorDark: '#c62828',

    // orange
    orangeLight: '#fbe9e7',
    orangeMain: '#ffab91',
    orangeDark: '#d84315',

    // warning
    warningLight: '#fff8e1',
    warningMain: '#ffe57f',
    warningDark: '#ffc107',

    // grey
    grey50: '#f8fafc',
    grey100: '#eef2f6',
    grey200: '#e3e8ef',
    grey300: '#cdd5df',
    grey500: '#697586',
    grey600: '#4b5565',
    grey700: '#364152',
    grey900: '#121926',

    // ==============================|| DARK THEME VARIANTS ||============================== //

    // paper & background
    darkBackground: '#1a223f',
    darkPaper: '#111936',

    // dark 800 & 900
    darkLevel1: '#29314f',
    darkLevel2: '#212946',

    // primary dark
    darkPrimaryLight: '#eef2f6',
    darkPrimaryMain: '#2196f3',
    darkPrimaryDark: '#1e88e5',
    darkPrimary200: '#90caf9',
    darkPrimary800: '#1565c0',

    // secondary dark
    darkSecondaryLight: '#d1c4e9',
    darkSecondaryMain: '#7c4dff',
    darkSecondaryDark: '#651fff',
    darkSecondary200: '#b39ddb',
    darkSecondary800: '#6200ea',

    // text variants
    darkTextTitle: '#d7dcec',
    darkTextPrimary: '#bdc8f0',
    darkTextSecondary: '#8492c4',
};

export default colors;
